import { ReactNode } from 'react'
import styles from './AppContainer.module.scss'

interface AppContainerProps {
  children: ReactNode
  className?: string
}

export const AppContainer = ({ children, className }: AppContainerProps) => {
  return (
    <div className={`${styles.container} ${className || ''}`}>
      {children}
    </div>
  )
} 